import { createSlice } from '@reduxjs/toolkit';

export interface WorkplaceTermItemsState {
	fieldOfCare?: string;
}

const initialState: WorkplaceTermItemsState = {
	fieldOfCare: undefined,
};

export const workplaceTermItemsSlice = createSlice({
	name: 'workplaceTermItems',
	initialState,
	reducers: {
		setFieldOfCareProvided: (state, { payload }) => {
			state.fieldOfCare = payload;
		},
	},
});

export const { setFieldOfCareProvided } = workplaceTermItemsSlice.actions;
export const selectFieldOfCare = (state: any) =>
	state.workplaceTermItems.fieldOfCare;

export default workplaceTermItemsSlice.reducer;
